import React, { FC } from 'react';
import { PageHeader, TermsLoader, UserStateComponent } from '../../components';
import { useTranslation } from '../../translations';

export const VendorPolicies: FC = () => {
  const { ts } = useTranslation();
  return (
    <UserStateComponent>
      <div id="vendorTerms">
        <PageHeader>{ts('common.vendor_policy')}</PageHeader>
        <TermsLoader name="vendor" />
      </div>
    </UserStateComponent>
  );
};
